import React from 'react'
import ParentStyles from '../../styles'
import { ArrowRight } from 'react-feather'
import Background from '~/assets/img/backgrounds/insights-card-bg.png'
import { FormattedMessage, useIntl } from 'react-intl'
import Styles from './styles'

export default function InsightsSection({ views = 0 }) {
  const intl = useIntl()
  return (
    <Styles.Container>
      <img src={Background} />
      <Styles.Content>
        <Styles.Title>
          {<FormattedMessage id={'homeInsightsTitle'} />}
        </Styles.Title>
        <Styles.DescriptionAndButton>
          <Styles.Description>
            <div
              dangerouslySetInnerHTML={{
                __html: intl
                  .formatMessage({ id: 'homeInsightsDescription' })
                  .replace('{{count}}', refineViews(views)),
              }}
            />
          </Styles.Description>
          <Styles.ButtonWrapper>
            <a href="/insights">
              <ParentStyles.PrimaryButton>
                <span>
                  <FormattedMessage id={'homeInsightsButton'} />
                </span>
                <ArrowRight width={16} />
              </ParentStyles.PrimaryButton>
            </a>
          </Styles.ButtonWrapper>
        </Styles.DescriptionAndButton>
      </Styles.Content>
    </Styles.Container>
  )
}

const refineViews = (views = 0) => {
  if (views > 1000000) {
    return `${(views / 1000000).toFixed(1)}M`
  }
  if (views > 1000) {
    return `${(views / 1000).toFixed(1)}K`
  }
  return views.toString()
}
